export const toyotaJousto = {
    toyotaLoanElement() {
        return $('#toyotaLoan');
    },
    getIsBalloon() {
        return this.toyotaLoanElement().data('is-balloon') || 0;
    },
    setIsBalloon(value) {
        this.toyotaLoanElement().data('is-balloon', value);
    },
    removeGreenEffect() {
        $('.greenFadeEffectToyota').removeClass('updateSec');
    },
    downPayment() {
        let maxAllowedDownPayment = this.toyotaLoanElement().data('max-down-payment');
        let minAllowedDownPayment = this.toyotaLoanElement().data('min-down-payment');
        let downPaymentValue = parseInt($('#toyotaDownPayment').val(), 10);
        if (downPaymentValue > maxAllowedDownPayment) {
            $('#toyotaDownPayment').val(maxAllowedDownPayment);
        } else if (downPaymentValue < minAllowedDownPayment) {
            $('#toyotaDownPayment').val(minAllowedDownPayment);
        }

        this.calculate();
    },
    balloonAmount() {
        let toyotaAdPrice = this.toyotaLoanElement().data('ad-price');
        let toyotaBalloonMinPercentage = this.toyotaLoanElement().data('balloon-min-percent');
        let toyotaBalloonMinAmount = (toyotaAdPrice * toyotaBalloonMinPercentage) / 100;
        let toyotaFundableAmount = parseInt($('#toyotaGuaranteedRefundPrice').text(), 10);
        let balloonValue = parseInt($('#toyotaBiggerLastPayment').val(), 10);
        this.setIsBalloon(1);
        if (balloonValue > toyotaFundableAmount) {
            $('#toyotaBiggerLastPayment').val(toyotaFundableAmount);
            this.setIsBalloon(0);
        } else if (balloonValue < toyotaBalloonMinAmount) {
            $('#toyotaBiggerLastPayment').val(toyotaBalloonMinAmount);
        }

        this.calculate();
    },
    fullContractPeriod() {
        let toyotaKmInterval = this.toyotaLoanElement().data('km-interval');
        let toyotaMaxContract = this.toyotaLoanElement().data('km-max-contract');
        let toyotaMinContract = this.toyotaLoanElement().data('km-min-contract');
        let months = $('#toyotaFullContractPeriod :selected').val();
        let year = parseInt(months, 10) / 12;
        let km = $('#toyotaMileagePerYear').val() * year;
        if (km < toyotaMinContract) {
            while (km < toyotaMinContract) {
                km = (km / year + toyotaKmInterval) * year;
            }
        } else if (km > toyotaMaxContract) {
            while (km > toyotaMaxContract) {
                km = (km / year - toyotaKmInterval) * year;
            }
        }
        $('#toyotaMileagePerYear').val(km / year);

        this.calculate();
    },
    mileagePerYear() {
        let toyotaMaxContract = this.toyotaLoanElement().data('km-max-contract');
        let toyotaMinContract = this.toyotaLoanElement().data('km-min-contract');
        let months = $('#toyotaFullContractPeriod :selected').val();
        let year = parseInt(months, 10) / 12;
        let km = $('#toyotaMileagePerYear').val() * year;

        if (km < toyotaMinContract) {
            while (km < toyotaMinContract) {
                year++;
                km = $('#toyotaMileagePerYear').val() * year;
            }
        } else if (km > toyotaMaxContract) {
            while (km > toyotaMaxContract) {
                year--;
                km = $('#toyotaMileagePerYear').val() * year;
            }
        }
        $('#toyotaFullContractPeriod').val(year * 12);

        this.calculate();
    },
    calculate() {
        let downPayment = $('#toyotaDownPayment').val();
        let balloon = toyotaJousto.getIsBalloon() ? $('#toyotaBiggerLastPayment').val() : 0;
        let months = $('#toyotaFullContractPeriod :selected').val();
        let averageKilometers = $('#toyotaMileagePerYear').val() * (parseInt(months, 10) / 12);
        let registerNumber = this.toyotaLoanElement().data('register-number');
        let adPrice = this.toyotaLoanElement().data('ad-price');
        let kilometers = this.toyotaLoanElement().data('ad-kilometers');
        let toyotaFinanceKey = this.toyotaLoanElement().data('finance-key');

        $.ajax({
            type: 'GET',
            url: Routing.generate('finance_toyota_jousto'),
            data: {
                downPayment,
                months,
                averageKilometers,
                registerNumber,
                toyotaFinanceKey,
                adPrice,
                kilometers,
                balloon,
                type: 'Jousto',
            },
            success(data) {
                $('.greenFadeEffectToyota').addClass('updateSec');

                $('#toyotaXmlData').val(data.loanXmlData);
                $('#toyotaMonthlyPayment').html(Math.round(data.monthly_installment));
                $('#toyotaLoanAmount').html(Math.round(data.fundable_part_with_establishing_cost));
                $('#toyotaGuaranteedRefundPrice').html(Math.round(data.gfv));
                $('#toyotaBiggerLastPayment').val(Math.round(data.balloon));
                $('#toyotaNominalInterest').html(commonUtils.numberFormatByLocale(data.interest * 100).toFixed(2));
                $('#toyotaEstablishingCost').html(Math.round(data.establishingcost));
                $('#toyotaHandlingFee').html(Math.round(data.handlingfee));
                $('#toyotaAnnualPercentageRate').html(
                    commonUtils.numberFormatByLocale((data.effective_interest * 100).toFixed(2))
                );
                $('#toyotaCreditCost').html(Math.round(data.credit_costs));
                $('#toyotaCreditPlusExpenses').html(Math.round(data.credit_plus_expenses));

                setTimeout(toyotaJousto.removeGreenEffect, 1000);
            },
        });
    },
};

export const toyotaOsamaksu = {
    toyotaLoanElement() {
        return $('#toyotaLoan');
    },
    getMaxAllowedDownPayment() {
        return this.toyotaLoanElement().data('max-down-payment');
    },
    getMinAllowedDownPayment() {
        return this.toyotaLoanElement().data('min-down-payment');
    },
    getMaxBalloonAmount() {
        return this.toyotaLoanElement().data('balloon-max');
    },
    getMinBalloonAmount() {
        return this.toyotaLoanElement().data('balloon-min');
    },
    setMaxAllowedDownPayment(amount) {
        this.toyotaLoanElement().data('max-down-payment', amount);
    },
    setMinAllowedDownPayment(amount) {
        this.toyotaLoanElement().data('min-down-payment', amount);
    },
    setMaxBalloonAmount(amount) {
        this.toyotaLoanElement().data('balloon-max', amount);
    },
    setMinBalloonAmount(amount) {
        this.toyotaLoanElement().data('balloon-min', amount);
    },
    removeGreenEffect() {
        $('.greenFadeEffectToyota').removeClass('updateSec');
    },
    downPayment() {
        let downPaymentValue = parseInt($('#toyotaDownPayment').val(), 10);
        if (downPaymentValue > this.getMaxAllowedDownPayment()) {
            $('#toyotaDownPayment').val(this.getMaxAllowedDownPayment());
        } else if (downPaymentValue < this.getMinAllowedDownPayment()) {
            $('#toyotaDownPayment').val(this.getMinAllowedDownPayment());
        }

        this.calculate();
    },
    balloonAmount() {
        let balloonValue = parseInt($('#toyotaBiggerLastPayment').val(), 10);
        if (balloonValue > this.getMaxBalloonAmount()) {
            $('#toyotaBiggerLastPayment').val(this.getMaxBalloonAmount());
        } else if (balloonValue < this.getMinBalloonAmount()) {
            $('#toyotaBiggerLastPayment').val(this.getMinBalloonAmount());
        }

        this.calculate();
    },
    calculate() {
        let downPayment = $('#toyotaDownPayment').val();
        let balloon = $('#toyotaBiggerLastPayment').val();
        let maxBalloon = toyotaOsamaksu.getMaxBalloonAmount();
        let months = $('#toyotaFullContractPeriod :selected').val();
        let adPrice = this.toyotaLoanElement().data('ad-price');
        let brand = this.toyotaLoanElement().data('ad-brand');
        let model = this.toyotaLoanElement().data('ad-model');
        let commissionDate = this.toyotaLoanElement().data('commission-date');
        let toyotaFinanceKey = this.toyotaLoanElement().data('finance-key');
        let registerNumber = this.toyotaLoanElement().data('register-number');
        let kilometers = this.toyotaLoanElement().data('ad-kilometers');

        $.ajax({
            type: 'GET',
            url: Routing.generate('finance_toyota_osamaksu'),
            data: {
                downPayment,
                balloon,
                maxBalloon,
                months,
                adPrice,
                brand,
                model,
                commissionDate,
                toyotaFinanceKey,
                registerNumber,
                kilometers,
                type: 'Osamaksu',
            },
            success(data) {
                $('.greenFadeEffectToyota').addClass('updateSec');

                // Update down payment and balloon field max and min value after every response
                toyotaOsamaksu.setMaxAllowedDownPayment(Math.round(data.downpayment_max));
                toyotaOsamaksu.setMinAllowedDownPayment(Math.round(data.downpayment_min));
                toyotaOsamaksu.setMaxBalloonAmount(Math.round(data.balloon_max));
                toyotaOsamaksu.setMinBalloonAmount(Math.round(data.balloon_min));

                $('#toyotaXmlData').val(data.loanXmlData);
                $('#toyotaMonthlyPayment').html(Math.round(data.monthly_installment));
                $('#toyotaLoanAmount').html(Math.round(data.fundable_part_with_establishing_cost));
                $('#toyotaDownPayment').val(Math.round(data.downpayment));
                $('#toyotaBiggerLastPayment').val(Math.round(data.balloon));
                $('#toyotaNominalInterest').html((data.interest * 100).toFixed(2));
                $('#toyotaEstablishingCost').html(Math.round(data.establishingcost));
                $('#toyotaHandlingFee').html(Math.round(data.handlingfee));
                $('#toyotaAnnualPercentageRate').html((data.effective_interest * 100).toFixed(2));
                $('#toyotaCreditCost').html(Math.round(data.credit_costs));
                $('#toyotaCreditPlusExpenses').html(Math.round(data.credit_plus_expenses));

                setTimeout(toyotaOsamaksu.removeGreenEffect, 1000);
            },
        });
    },
};
